var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1177 8.22607H10.1177C9.01311 8.22607 8.11768 9.1215 8.11768 10.2261V19.2261C8.11768 20.3306 9.01311 21.2261 10.1177 21.2261H19.1177C20.2222 21.2261 21.1177 20.3306 21.1177 19.2261V10.2261C21.1177 9.1215 20.2222 8.22607 19.1177 8.22607Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11768 14.2261H3.11768C2.58724 14.2261 2.07853 14.0154 1.70346 13.6403C1.32839 13.2652 1.11768 12.7565 1.11768 12.2261V3.22607C1.11768 2.69564 1.32839 2.18693 1.70346 1.81186C2.07853 1.43679 2.58724 1.22607 3.11768 1.22607H12.1177C12.6481 1.22607 13.1568 1.43679 13.5319 1.81186C13.907 2.18693 14.1177 2.69564 14.1177 3.22607V4.22607",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.aa5ecede8f19b8a65d4acbc635ad4893.svg";
export { ForwardRef as ReactComponent };